import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MainPage } from "@/pages/MainPage.js";
import { TestPage } from "@/pages/TestPage.js";
import { TestResultPage } from "@/pages/TestResultPage.js";
import { SurveyPage } from "@/pages/SurveyPage.js";
import { SurveyDonePage } from "@/pages/SurveyDonePage.js";
import { VerifyEmailPage } from "@/pages/VerifyEmailPage.js";

/** Splash DOM 정리: CSS 애니메이션이 끝난 뒤 요소를 제거합니다. */
function useSplashCleanup() {
  useEffect(() => {
    const id = setTimeout(() => {
      document.getElementById("splash")?.remove();
    }, 1700);
    return () => clearTimeout(id);
  }, []);
}

export function App() {
  const location = useLocation();
  useSplashCleanup();

  return (
    /* aurora-bg에 will-change: filter 없음 → fixed 모달이 viewport 기준으로 정확히 위치됨 */
    <div className="aurora-bg min-h-screen">
      <div className="mx-auto max-w-md min-h-screen">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.18, ease: "easeInOut" }}
          >
            <Routes location={location}>
              <Route path="/" element={<MainPage />} />
              <Route path="/t/:slug" element={<TestPage />} />
              <Route path="/t/:slug/r/:resultSlug" element={<TestResultPage />} />
              <Route path="/s/:slug" element={<SurveyPage />} />
              <Route path="/s/:slug/done" element={<SurveyDonePage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
